<template>
  <div class="books">
    <div class="intro">
      <h2>Boekenplank</h2>
      <p class="light">
        Dit is een overzicht van al jouw e-books.
      </p>
    </div>
    <OwnedBooks/>
  </div>
</template>

<script>
import OwnedBooks from "./books/OwnedBooks.vue";
import ContinueReading from "./books/ContinueReading.vue";

export default {
  name: "Books",
  components: {
    ContinueReading,
    OwnedBooks
  }
};
</script>
